import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';

// Google OAuth temporarily disabled - this page redirects to login
const AuthCallback = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/auth', { replace: true });
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center" style={{ background: 'var(--pd-bg)' }}
      data-testid="auth-callback">
      <div className="text-center">
        <Loader2 className="w-8 h-8 animate-spin mx-auto mb-3" style={{ color: '#22D3EE' }} />
        <p className="text-sm" style={{ color: 'var(--pd-text2)' }}>Redirecting...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
